import { Route, Routes } from "react-router-dom";
import AuthPage from "../../Pages/AuthPage";
import ForgotPasswordPage from "../../Pages/ForgotPasswordPage";
import PrivacyPage from "../../Pages/PrivacyPage";

const AuthContentProvider = () => {
  return (
    <>
      <Routes>
        <Route
          path={"/authorization"}
          element={<AuthPage authMode={"singIn"} />}
        />
        <Route
          path={"/registration/:refKey?"}
          element={<AuthPage authMode={"singUp"} />}
        />
        <Route path={"/reset-password/*"} element={<ForgotPasswordPage />} />
        <Route
          path={"/registration/privacy_policy"}
          element={<PrivacyPage content={"privacyPolicy"} />}
        />
        <Route
          path={"/registration/terms_of_use"}
          element={<PrivacyPage content={"termsOfUse"} />}
        />
        <Route
          path={"/authByToken/:authToken"}
          element={<AuthPage authMode={"singIn"} />}
        />
      </Routes>
    </>
  );
};

export default AuthContentProvider;
